import { createReducer } from '../utils';
import {
  RELATED_SNAPSHOTS_FEED_SUCCESS,
  RELATED_SNAPSHOTS_FEED_REQUEST,
  RELATED_SNAPSHOTS_FEED_FAILURE,
  RELATED_SNAPSHOTS_FEED_RESET,
  RELATED_SNAPSHOTS_MOUNTED,
} from '../constants';

const initialState = {
  data: [],
  isFetching: true,
  reset: false,
  mounted: false,
};

export default createReducer(initialState, {
  [RELATED_SNAPSHOTS_FEED_SUCCESS]: (state, payload) => {
    return { ...state, isFetching: false, reset: false, data: payload.data };
  },
  [RELATED_SNAPSHOTS_FEED_RESET]: (state, payload) => {
    return { ...state, reset: true, isFetching: true, data: null };
  },
  [RELATED_SNAPSHOTS_FEED_REQUEST]: (state, payload) => {
    const newState = {
      isFetching: true,
      reset: payload.reset,
      data: payload.reset ? [] : state.data,
    };

    return { ...state, ...newState };
  },
  [RELATED_SNAPSHOTS_FEED_FAILURE]: (state) => {
    return { ...state, isFetching: false };
  },
  [RELATED_SNAPSHOTS_MOUNTED]: (state) => {
    return { ...state, mounted: true };
  },
});
